module.exports = __webpack_public_path__ + "img/consulta-ja-logo.165e9565.png";